/* Boboné — loading veil controller.
   Reveals a single centered clover over a soft scrim, but ONLY for a genuine
   add-to-cart wait, and ONLY after a short delay — so quick adds never flash
   it ("solo cuando de verdad está cargando"). Everything else (predictive
   search, filters, image zoom, the variant-change refresh) keeps its quiet
   inline clover.

   Timing model (avoids both kinds of flash):
     • SHOW_DELAY  — don't reveal before this; sub-300ms adds show nothing.
     • MIN_VISIBLE — once revealed, stay up at least this long, so a request
                     that finishes just after the delay can't blink the veil.

   Purely additive: it wraps window.fetch but passes every non-matching request
   straight through untouched, so it can never change existing behaviour. */
(function () {
  var SHOW_DELAY = 300; // ms — below this the add is "instant"; no veil.
  var MIN_VISIBLE = 450; // ms — once shown, keep it up at least this long.
  var MAX_VISIBLE = 12000; // ms — safety net so a hung request can't trap the user.

  var overlay = null;
  var showTimer = null;
  var hideTimer = null;
  var safetyTimer = null;
  var shownAt = 0;
  var pending = 0;

  function node() {
    if (!overlay) overlay = document.getElementById('BoboneLoadingOverlay');
    return overlay;
  }

  function isVisible() {
    var el = node();
    return !!el && el.classList.contains('is-visible');
  }

  function reveal() {
    var el = node();
    if (!el) return;
    el.classList.add('is-visible');
    shownAt = Date.now();
    window.clearTimeout(safetyTimer);
    safetyTimer = window.setTimeout(forceHide, MAX_VISIBLE);
  }

  function removeVeil() {
    var el = node();
    if (el) el.classList.remove('is-visible');
    window.clearTimeout(safetyTimer);
  }

  function forceHide() {
    pending = 0;
    window.clearTimeout(hideTimer);
    hideTimer = null;
    removeVeil();
  }

  function show() {
    pending += 1;
    // A new wait cancels any pending fade-out and keeps the veil up.
    window.clearTimeout(hideTimer);
    hideTimer = null;
    if (isVisible() || showTimer !== null) return;
    showTimer = window.setTimeout(function () {
      showTimer = null;
      if (pending > 0) reveal();
    }, SHOW_DELAY);
  }

  function hide() {
    if (pending > 0) pending -= 1;
    if (pending > 0) return;

    // Still within the delay window — nothing was ever shown, so no flash.
    if (showTimer !== null) {
      window.clearTimeout(showTimer);
      showTimer = null;
      return;
    }
    if (!isVisible()) return;

    var remaining = MIN_VISIBLE - (Date.now() - shownAt);
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(removeVeil, remaining > 0 ? remaining : 0);
  }

  // Exposed in case another script ever wants to drive the veil directly.
  window.BoboneOverlay = { show: show, hide: hide };

  // Only adding to cart gets the veil — the deliberate "buying" moment.
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/i;

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input) {
    var url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
    } catch (e) {
      url = '';
    }

    if (!CART_ADD.test(url)) {
      return nativeFetch.apply(window, arguments);
    }

    show();
    var settled = false;
    var done = function () {
      if (settled) return;
      settled = true;
      hide();
    };

    return nativeFetch.apply(window, arguments).then(
      function (response) {
        done();
        return response;
      },
      function (error) {
        done();
        throw error;
      }
    );
  };
})();
